export default __webpack_public_path__ + "static/media/logo6.2aee65ba.png";